/* eslint-disable no-console */
export const state = () => ({
  claims: [],
  claimsTotalCount: null,
  claimsLoading: false,
  claimsError: '',
})
export const getters = {
  claims(state) {
    return state.claims
  },
  claimsTotalCount(state) {
    return state.claimsTotalCount
  },
  claimsLoading(state) {
    return state.claimsLoading
  },
}
export const mutations = {
  SET_CLAIM: (state, claims) => {
    state.claims = claims
  },
  SET_CLAIM_TOTAL_COUNT: (state, claimsTotalCount) => {
    state.claimsTotalCount = claimsTotalCount
  },
  SET_CLAIM_LOADING: (state, payload) => {
    state.claimsLoading = payload
  },
  SET_CLAIM_ERROR: (state, payload) => {
    state.claimsError = payload
  },
}
export const actions = {
  async fetchClaims({ commit }, policyCode) {
    commit('SET_CLAIM_LOADING', true)
    try {
      const claims = await this.$axios.$get(
        `/api/claim/v1/claims/${policyCode}`,
        { timeout: 10000 }
      )
      console.log('data', claims)
      commit('SET_CLAIM', claims)
      commit('SET_CLAIM_TOTAL_COUNT', claims.length)
      commit('SET_CLAIM_LOADING', false)
      commit('SET_CLAIM_ERROR', '')
    } catch (error) {
      console.log('fetch claims by email error', error)
      commit('SET_CLAIM', [])
      commit('SET_CLAIM_LOADING', false)
      commit('SET_CLAIM_ERROR', error)
    }
  },
}
